import React from 'react';

import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import CMASummaryBorder from './CMASummaryBorder';
import CMASummaryTableDataValuesDifference from './CMASummaryTableDataValuesDifference';
import { CMASummaryFilters } from './types';
import { isDefined, parseCMASummaryCommunityData } from './utils';

type Props = {
  roomData: number | number[];
  dataTestId?: string;
};

const Title = styled.div`
  font-family: var(--font-regular);
  font-size: 14px;
`;

const CMASummaryTableDataRoomComparison = ({ roomData, dataTestId }: Props) => {
  const { viewFilters } = useCommunityViewContext();
  const filters = viewFilters as CMASummaryFilters;
  const { dataItemOne } = parseCMASummaryCommunityData(roomData, filters?.viewOptions?.valueDisplay);
  const totalSum = dataItemOne?.value;
  const totalSumDifference = dataItemOne?.difference;

  return (
    <>
      <CMASummaryBorder />
      {isDefined(totalSum) ? (
        <Title data-test-id={dataTestId}>
          ${totalSum.toLocaleString()}
          <CMASummaryTableDataValuesDifference difference={totalSumDifference} />
        </Title>
      ) : (
        <div data-test-id={dataTestId}>-</div>
      )}
    </>
  );
};

export default CMASummaryTableDataRoomComparison;
